import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
        <p className="text-black/60 text-sm">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;